import { render, staticRenderFns } from "./statsCustomerCampaign.vue?vue&type=template&id=72ecd1d3&"
import script from "./statsCustomerCampaign.vue?vue&type=script&lang=js&"
export * from "./statsCustomerCampaign.vue?vue&type=script&lang=js&"
import style0 from "./statsCustomerCampaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports